import React from 'react';
import { ReactComponent as DocumentIcon } from "../../assets/icons/document.svg";
import {
    AttachmentOuterWrapper,
    FileExtension,
    FileIconWrapper,
    FileInfoContainer,
    FileName,
    FileTextInfo,
    RemoveButton
} from './ChatInput.styled';

interface FileAttachmentListProps {
    files: File[];
    onRemove: (index: number) => void;
}

export const FileAttachmentList: React.FC<FileAttachmentListProps> = ({
    files,
    onRemove
}) => {
    if (files.length === 0) {
        return null;
    }

    return (
        <AttachmentOuterWrapper>
            {files.map((file, index) => (
                <FileInfoContainer key={`${file.name}-${index}`}>
                    <FileIconWrapper>
                        <DocumentIcon/>
                    </FileIconWrapper>
                    <FileTextInfo>
                        <FileName>{file.name.split('.').slice(0, -1).join('.')}</FileName>
                        <FileExtension>{file.name.split('.').pop()?.toUpperCase()}</FileExtension>
                    </FileTextInfo>
                    <RemoveButton onClick={() => onRemove(index)}/>
                </FileInfoContainer>
            ))}
        </AttachmentOuterWrapper>
    );
};
